module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/main-visual-510d79aae1f8950fca63ca993359ce03.png";